import Modal from '@/components/UI/modal/Modal';
import useDevice from '@/hooks/useDevice';
import { FC, useState } from 'react';
import ReviewsModal from './reviewsModal/ReviewsModal';
import Drawer from '@/components/UI/drawer/Drawer';
import Button from '@/components/UI/button/Button';
import ReviewCard from '@/components/houses/_reusable/houseInfo/reviews/reusable/reviewCard/ReviewCard';
import ReviewCardSkeleton from '../reusable/reviewCardSkeleton/ReviewCardSkeleton';
import ReviewRateItem from './reviewRateItem/ReviewRateItem';
import { IconNames } from '@/components/UI/Types';
import Icon from '@/components/UI/icon/Icon';
import { getDaysPassed } from '@/helpers/jalaliDate';
import useDrawer from '@/hooks/useDrawer';
import styles from './ReviewsContainer.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
const reviewsCardItems = [1, 2, 3];
const Suggest = {
  1: 'dislike',
  2: 'no-idea',
  3: 'like'
};
type ReviewsContainerProps = {
  product: ProductItemTypes;
};
const ReviewsContainer: FC<ReviewsContainerProps> = ({
  product
}) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const [reviewIndex, setReviewIndex] = useState<number>();
  const {
    isMobile
  } = useDevice();
  const reviews = product?.reviews;
  const totalReviews = product?.reviews_count;
  const rateItems = [{
    icon: 'broom',
    title: 'نظافت',
    rate: product?.rates?.cleanliness
  }, {
    icon: 'clipboard-tick',
    title: 'تطابق اطلاعات',
    rate: product?.rates?.accuracy
  }, {
    icon: 'wallet-money',
    title: 'ارزش قیمت',
    rate: product?.rates?.value
  }, {
    icon: 'map',
    title: 'مسیر و دسترسی',
    rate: product?.rates?.accessibility
  }, {
    icon: 'user-square',
    title: 'نحوه میزبانی',
    rate: product?.rates?.host
  }, {
    icon: 'star-1',
    title: 'امتیاز اقامتگاه',
    rate: product?.rates?.rank
  }];
  return <>
      <Box component={'section'} className={styles['reviews-container']} data-sentry-element="Box" data-sentry-source-file="ReviewsContainer.tsx">
        {totalReviews === 0 ? <>
            <Typography variant="bodyL_Bold" color="neutral_800" component="h2">
              امتیاز و نظرات کاربران
            </Typography>

            <Box className={styles['empty-reviews-box']}>
              <Icon name="message-text" type="highEmphasis" size={'large'} />
              <Typography variant="bodyM">
                هنوز نظری برای این اقامتگاه ثبت نشده است.
              </Typography>
            </Box>
          </> : <>
            <Box className={styles['review-header']}>
              <Typography variant="bodyL_Bold" color="neutral_800" component="h2">
                امتیاز و نظرات کاربران
              </Typography>
              {!isMobile && Number(totalReviews) > 3 && <Box>
                  <Button format="text" size="small" onClick={() => drawerOpen('REVIEWS')} endIcon={'arrow-left-1'}>
                    مشاهده همه نظرات ({totalReviews})
                  </Button>
                </Box>}
            </Box>
            <Box className={styles['reviews-rate-items']}>
              {rateItems.map(({
            icon,
            title,
            rate
          }, index) => <ReviewRateItem icon={icon as IconNames} title={title} rate={rate as number} key={'REVIEW_RATE_ITEM_' + index} />)}
            </Box>
            <Box component={'section'} className={styles['review-preview-wrapper']}>
              {!reviews ? reviewsCardItems?.map(index => <ReviewCardSkeleton key={'REVIEWS_ITEM_SKELETON_INDEX_' + index} />) : reviews?.slice(0, 3)?.map((review, index) => <ReviewCard image={review?.user?.avatar_path} date={getDaysPassed(String(review?.checkout_date))} name={review?.user?.name} rate={review?.point_average} reviewContent={review?.comment} suggestStatus={Suggest?.[review?.suggest]} reply={review?.host_reply} handleOpen={() => {
            drawerOpen('REVIEWS');
            setReviewIndex(index);
          }} isBrief={true} key={'REVIEWS_ITEM_INDEX_' + index}
          // showMore={
          //   review?.comment?.length > 100 ||
          //   !!review?.host_reply?.comment_id ||
          //   !!review?.positives?.length ||
          //   !!review?.negatives?.length
          // }
          />)}
            </Box>
            {isMobile && Number(totalReviews) > 3 && <Button format="text" size="small" onClick={() => drawerOpen('REVIEWS')} endIcon={'arrow-left-1'}>
                مشاهده همه نظرات ({totalReviews})
              </Button>}
          </>}
      </Box>
      {isMobile ? <Drawer fullHeight open={isDrawerOpen('REVIEWS')} onClose={() => {
      drawerClose();
      setReviewIndex(undefined);
    }}>
          <ReviewsModal id={product?.id} data={product} handleClose={() => drawerClose()} reviewIndex={reviewIndex} handleReviewIndex={() => {
        setReviewIndex(undefined);
      }} open={isDrawerOpen('REVIEWS')} />
        </Drawer> : <Modal open={isDrawerOpen('REVIEWS')} onClose={() => {
      drawerClose();
    }}>
          <ReviewsModal id={product?.id} data={product} open={isDrawerOpen('REVIEWS')} reviewIndex={reviewIndex} handleClose={() => {
        drawerClose();
        setReviewIndex(undefined);
      }} handleReviewIndex={() => {
        setReviewIndex(undefined);
      }} />
        </Modal>}
    </>;
};
export default ReviewsContainer;